import axios from 'axios';

axios.defaults.baseURL = window.config.REACT_APP_BASE_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

export const API_URL = axios.defaults.baseURL + '/api';
